<template>
    <div class="tab-content">
        <div class="controls">
            <div class="transformer-container">
                <div class="input-section">
                    <h3>Конвертация стилей</h3>
                    <div class="json-input-group">
                        <div class="json-input-section">
                            <label for="plan-json">JSON данные плана:</label>
                            <div 
                                class="drop-zone"
                                :class="{ 'drag-over': isDragOverPlan, 'has-error': planJsonError }"
                                @drop="handlePlanFileDrop"
                                @dragover.prevent="handlePlanDragOver"
                                @dragleave="handlePlanDragLeave"
                            >
                                <div class="drop-zone-content" v-if="!planJson">
                                    <div class="drop-zone-icon">
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10 9H9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Перетащите JSON файл сюда</p>
                                    <span class="drop-zone-or">или</span>
                                    <button type="button" class="btn secondary" @click="triggerPlanFileInput">
                                        Выберите файл
                                    </button>
                                    <input 
                                        type="file" 
                                        ref="planFileInput"
                                        accept=".json,application/json"
                                        @change="handlePlanFileSelect"
                                        style="display: none"
                                    >
                                </div>
                                <div class="file-info" v-else>
                                    <div class="file-success">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Файл плана загружен
                                    </div>
                                    <button type="button" class="btn remove-file" @click="clearPlanJson">
                                        Удалить
                                    </button>
                                </div>
                            </div>
                            <textarea 
                                id="plan-json"
                                v-model="planJson"
                                placeholder="Вставьте JSON данные плана здесь..."
                                class="json-textarea"
                                rows="12"
                                :class="{ 'has-error': planJsonError }"
                            ></textarea>
                            <div class="json-actions">
                                <button class="btn secondary" @click="clearPlanJson" :disabled="loading">
                                    Очистить
                                </button>
                                <button class="btn secondary" @click="formatPlanJson" :disabled="loading">
                                    Форматировать JSON
                                </button>
                            </div>
                            <div v-if="planJsonError" class="error-message">
                                {{ planJsonError }}
                            </div>
                        </div>

                        <div class="json-input-section">
                            <label for="config-json">Конфигурация (JSON):</label>
                            
                            <div class="config-selector">
                                <label for="config-select">Выберите конфигурацию:</label>
                                <select 
                                    id="config-select"
                                    v-model="selectedConfigId"
                                    @change="onConfigSelect"
                                    class="config-dropdown"
                                    :disabled="loading"
                                >
                                    <option value="">Выберите конфиг...</option>
                                    <option 
                                        v-for="config in availableConfigs" 
                                        :key="config.id"
                                        :value="config.id"
                                    >
                                        {{ config.name }}
                                    </option>
                                </select>
                                <div v-if="configLoading" class="loading-message">
                                    Загрузка конфигураций...
                                </div>
                            </div>

                            <div 
                                class="drop-zone"
                                :class="{ 'drag-over': isDragOverConfig, 'has-error': configJsonError }"
                                @drop="handleConfigFileDrop"
                                @dragover.prevent="handleConfigDragOver"
                                @dragleave="handleConfigDragLeave"
                            >
                                <div class="drop-zone-content" v-if="!configJson">
                                    <div class="drop-zone-icon">
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10 9H9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <p>Перетащите JSON файл конфигурации сюда</p>
                                    <span class="drop-zone-or">или</span>
                                    <button type="button" class="btn secondary" @click="triggerConfigFileInput">
                                        Выберите файл
                                    </button>
                                    <input 
                                        type="file" 
                                        ref="configFileInput"
                                        accept=".json,application/json"
                                        @change="handleConfigFileSelect"
                                        style="display: none"
                                    >
                                </div>
                                <div class="file-info" v-else>
                                    <div class="file-success">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Файл конфигурации загружен
                                    </div>
                                    <button type="button" class="btn remove-file" @click="clearConfigJson">
                                        Удалить
                                    </button>
                                </div>
                            </div>
                            <textarea 
                                id="config-json"
                                v-model="configJson"
                                class="json-textarea"
                                rows="8"
                                :class="{ 'has-error': configJsonError }"
                            ></textarea>
                            <div class="json-actions">
                                <button class="btn secondary" @click="clearConfigJson" :disabled="loading">
                                    Очистить
                                </button>
                                <button class="btn secondary" @click="formatConfigJson" :disabled="loading">
                                    Форматировать JSON
                                </button>
                                <button class="btn secondary" @click="loadDefaultConfig" :disabled="loading">
                                    Загрузить конфиг по умолчанию
                                </button>
                            </div>
                            <div v-if="configJsonError" class="error-message">
                                {{ configJsonError }}
                            </div>
                        </div>
                    </div>

                    <div class="action-buttons">
                        <button class="btn" @click="convertPlan" :disabled="!planJson || loading">
                            <span v-if="loading">Конвертация...</span>
                            <span v-else>Конвертировать</span>
                        </button>
                    </div>

                    <div v-if="error" class="error-message">
                        {{ error }}
                    </div>

                    <div v-if="result" class="result-section">
                        <div class="success-message">
                            ✅ {{ result.message }}
                        </div>
                        <div class="result-actions">
                            <button class="btn secondary" @click="copyResult">
                                Скопировать результат
                            </button>
                            <button class="btn secondary" @click="downloadResult">
                                Скачать JSON
                            </button>
                        </div>

                        <div class="json-preview">
                            <label>Результат конвертации:</label>
                            <pre class="json-output">{{ formattedResult }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, computed, onMounted } from 'vue'
    import api from '../services/api'

    export default {
        name: 'TransformerTab',
        setup() {
            const planJson = ref('')
            const configJson = ref('')
            const loading = ref(false)
            const error = ref('')
            const result = ref(null)
            const configLoading = ref(false)
            const availableConfigs = ref([])
            const selectedConfigId = ref('')

            const isDragOverPlan = ref(false)
            const planJsonError = ref('')
            const planFileInput = ref(null)

            const isDragOverConfig = ref(false)
            const configJsonError = ref('')
            const configFileInput = ref(null)

            const formattedResult = computed(() => {
                if (!result.value?.converted_plan) return ''
                return JSON.stringify(result.value.converted_plan, null, 2)
            })

            const fetchAvailableConfigs = async () => {
                configLoading.value = true
                try {
                    // Assuming you have an endpoint to get available configs
                    availableConfigs.value = await api.getStyleConfigs()
                } catch (e) {
                    console.error('Error fetching configs:', e)
                    error.value = 'Ошибка при загрузке конфигураций'
                } finally {
                    configLoading.value = false
                }
            }

            const loadSelectedConfig = async (configId) => {
                if (!configId) return
                
                loading.value = true
                try {
                    const config = await api.getStyleConfig(configId)
                    configJson.value = JSON.stringify(config, null, 2)
                    configJsonError.value = ''
                } catch (e) {
                    console.error('Error loading config:', e)
                    error.value = 'Ошибка при загрузке конфигурации'
                } finally {
                    loading.value = false
                }
            }

            const onConfigSelect = () => {
                if (selectedConfigId.value) {
                    loadSelectedConfig(selectedConfigId.value)
                } else {
                    configJson.value = ''
                }
            }

            const triggerPlanFileInput = () => {
                planFileInput.value?.click()
            }

            const handlePlanFileSelect = (event) => {
                const file = event.target.files[0]
                if (file) {
                    readPlanFile(file)
                }
            }

            const handlePlanDragOver = () => {
                isDragOverPlan.value = true
            }

            const handlePlanDragLeave = () => {
                isDragOverPlan.value = false
            }

            const handlePlanFileDrop = (event) => {
                event.preventDefault()
                isDragOverPlan.value = false

                const files = event.dataTransfer.files
                if (files.length > 0) {
                    const file = files[0]
                    readPlanFile(file)
                }
            }

            const readPlanFile = (file) => {
                if (file.type !== 'application/json' && !file.name.endsWith('.json')) {
                    planJsonError.value = 'Пожалуйста, выберите файл в формате JSON'
                    return
                }

                const reader = new FileReader()
                reader.onload = (e) => {
                    try {
                        const content = e.target.result
                        JSON.parse(content)
                        planJson.value = content
                        planJsonError.value = ''
                    } catch (e) {
                        planJsonError.value = 'Неверный формат JSON в файле: ' + e.message
                    }
                }
                reader.onerror = () => {
                    planJsonError.value = 'Ошибка при чтении файла'
                }
                reader.readAsText(file)
            }

            // Config file methods
            const triggerConfigFileInput = () => {
                configFileInput.value?.click()
            }

            const handleConfigFileSelect = (event) => {
                const file = event.target.files[0]
                if (file) {
                    readConfigFile(file)
                }
            }

            const handleConfigDragOver = () => {
                isDragOverConfig.value = true
            }

            const handleConfigDragLeave = () => {
                isDragOverConfig.value = false
            }

            const handleConfigFileDrop = (event) => {
                event.preventDefault()
                isDragOverConfig.value = false

                const files = event.dataTransfer.files
                if (files.length > 0) {
                    const file = files[0]
                    readConfigFile(file)
                }
            }

            const readConfigFile = (file) => {
                if (file.type !== 'application/json' && !file.name.endsWith('.json')) {
                    configJsonError.value = 'Пожалуйста, выберите файл в формате JSON'
                    return
                }

                const reader = new FileReader()
                reader.onload = (e) => {
                    try {
                        const content = e.target.result
                        JSON.parse(content)
                        configJson.value = content
                        configJsonError.value = ''
                        selectedConfigId.value = '' // Clear selected config when custom file is loaded
                    } catch (e) {
                        configJsonError.value = 'Неверный формат JSON в файле: ' + e.message
                    }
                }
                reader.onerror = () => {
                    configJsonError.value = 'Ошибка при чтении файла'
                }
                reader.readAsText(file)
            }

            const formatPlanJson = () => {
                try {
                    if (planJson.value.trim()) {
                        const parsed = JSON.parse(planJson.value)
                        planJson.value = JSON.stringify(parsed, null, 2)
                        error.value = ''
                        planJsonError.value = ''
                    }
                } catch (e) {
                    planJsonError.value = 'Неверный формат JSON плана: ' + e.message
                }
            }

            const formatConfigJson = () => {
                try {
                    if (configJson.value.trim()) {
                        const parsed = JSON.parse(configJson.value)
                        configJson.value = JSON.stringify(parsed, null, 2)
                        error.value = ''
                        configJsonError.value = ''
                    }
                } catch (e) {
                    configJsonError.value = 'Неверный формат JSON конфигурации: ' + e.message
                }
            }

            const clearPlanJson = () => {
                planJson.value = ''
                planJsonError.value = ''
                if (planFileInput.value) {
                    planFileInput.value.value = ''
                }
            }

            const clearConfigJson = () => {
                configJson.value = ''
                configJsonError.value = ''
                selectedConfigId.value = ''
                if (configFileInput.value) {
                    configFileInput.value.value = ''
                }
            }

            const loadDefaultConfig = () => {
                // Load the first available config as default
                if (availableConfigs.value.length > 0) {
                    selectedConfigId.value = availableConfigs.value[0].id
                    loadSelectedConfig(selectedConfigId.value)
                } else {
                    error.value = 'Нет доступных конфигураций'
                }
            }

            const convertPlan = async () => {
                if (!planJson.value.trim()) {
                    planJsonError.value = 'Пожалуйста, введите JSON данные плана'
                    return
                }

                loading.value = true
                error.value = ''
                result.value = null

                try {
                    const planData = JSON.parse(planJson.value)
                    let configData = null
                    let configName = "custom"
                    
                    if (configJson.value.trim()) {
                        configData = JSON.parse(configJson.value)
                    } else if (selectedConfigId.value) {
                        configName = selectedConfigId.value
                    }

                    const response = await api.convertPlanStyle(
                        planData, 
                        "WhiteBox", 
                        configName, 
                        configData
                    )
                    
                    result.value = response
                } catch (e) {
                    console.error('Conversion error:', e)
                    error.value = e.response?.data?.detail || 'Ошибка при конвертации'
                } finally {
                    loading.value = false
                }
            }

            const copyResult = async () => {
                try {
                    await navigator.clipboard.writeText(formattedResult.value)
                    alert('Результат скопирован в буфер обмена')
                } catch (e) {
                    console.error('Copy failed:', e)
                    alert('Ошибка при копировании')
                }
            }

            const downloadResult = () => {
                if (!result.value?.converted_plan) return

                const blob = new Blob([formattedResult.value], { type: 'application/json' })
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `transformer_converted_plan_${Date.now()}.json`
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(url)
            }

            onMounted(() => {
                fetchAvailableConfigs()
            })

            return {
                planJson,
                configJson,
                loading,
                error,
                result,
                configLoading,
                availableConfigs,
                selectedConfigId,
                isDragOverPlan,
                planJsonError,
                planFileInput,
                isDragOverConfig,
                configJsonError,
                configFileInput,
                formattedResult,
                fetchAvailableConfigs,
                loadSelectedConfig,
                onConfigSelect,
                triggerPlanFileInput,
                handlePlanFileSelect,
                handlePlanDragOver,
                handlePlanDragLeave,
                handlePlanFileDrop,
                triggerConfigFileInput,
                handleConfigFileSelect,
                handleConfigDragOver,
                handleConfigDragLeave,
                handleConfigFileDrop,
                formatPlanJson,
                formatConfigJson,
                clearPlanJson,
                clearConfigJson,
                loadDefaultConfig,
                convertPlan,
                copyResult,
                downloadResult
            }
        }
    }
</script>

<style scoped>
.transformer-container {
    background: #f8faff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.input-section h3 {
    margin: 0 0 20px 0;
    color: var(--text-dark);
    font-weight: 600;
}

.json-input-group {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 20px;
}

.json-input-section {
    flex: 1;
}

.json-input-section label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-dark);
}

.config-selector {
    margin-bottom: 15px;
}

.config-selector label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-dark);
}

.config-dropdown {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d0d9e7;
    border-radius: 6px;
    background: var(--card-bg);
    font-size: 14px;
    margin-bottom: 10px;
}

.config-dropdown:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(74, 108, 247, 0.1);
}

.loading-message {
    color: var(--text-light);
    font-size: 14px;
    font-style: italic;
}

.drop-zone {
    border: 2px dashed #d0d9e7;
    border-radius: 8px;
    padding: 30px 20px;
    text-align: center;
    margin-bottom: 15px;
    transition: all 0.3s ease;
    background: var(--card-bg);
}

.drop-zone.drag-over {
    border-color: var(--primary-color);
    background-color: rgba(74, 108, 247, 0.05);
}

.drop-zone.has-error {
    border-color: var(--error-color);
}

.drop-zone-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.drop-zone-icon {
    color: #d0d9e7;
    margin-bottom: 8px;
}

.drop-zone p {
    margin: 0;
    color: var(--text-dark);
    font-weight: 500;
}

.drop-zone-or {
    color: var(--text-light);
    font-size: 14px;
}

.file-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: #e8f5e8;
    border-radius: 6px;
    border: 1px solid #c8e6c9;
}

.file-success {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2e7d32;
    font-weight: 500;
}

.file-success svg {
    stroke: #2e7d32;
}

.remove-file {
    background: transparent;
    color: var(--error-color);
    border: 1px solid var(--error-color);
    padding: 4px 12px;
    font-size: 12px;
    margin-left: 7px;
}

.remove-file:hover {
    background: var(--error-color);
    color: white;
}

.json-textarea {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #d0d9e7;
    border-radius: 8px;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    line-height: 1.4;
    resize: vertical;
    background: var(--card-bg);
    box-sizing: border-box;
    min-height: 200px;
}

.json-textarea.has-error {
    border-color: var(--error-color);
}

.json-textarea:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(74, 108, 247, 0.1);
}

.json-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
    flex-wrap: wrap;
}

.action-buttons {
    display: flex;
    gap: 10px;
    margin: 25px 0;
    justify-content: center;
}

.action-buttons .btn {
    min-width: 200px;
    font-size: 16px;
    padding: 14px 24px;
}

.error-message {
    background: #ffeaea;
    color: var(--error-color);
    padding: 12px 15px;
    border-radius: 8px;
    margin: 15px 0;
    border: 1px solid #ffcdd2;
}

.success-message {
    background: #e8f5e8;
    color: #2e7d32;
    padding: 12px 15px;
    border-radius: 8px;
    margin: 15px 0;
    border: 1px solid #c8e6c9;
    font-weight: 600;
}

.result-actions {
    display: flex;
    gap: 10px;
    margin: 15px 0;
    flex-wrap: wrap;
}

.json-preview {
    margin-top: 20px;
}

.json-preview label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-dark);
}

.json-output {
    background: #2c3e50;
    color: #ecf0f1;
    padding: 15px;
    border-radius: 8px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.4;
    overflow-x: auto;
    max-height: 500px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
}

@media (min-width: 992px) {
    .json-input-group {
        flex-direction: row;
    }
    
    .json-input-section {
        min-width: 0;
    }
}

@media (max-width: 768px) {
    .json-actions,
    .result-actions,
    .action-buttons {
        flex-direction: column;
    }
    
    .btn {
        width: 100%;
    }
    
    .action-buttons .btn {
        min-width: auto;
    }
    
    .file-info {
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }
    
    .config-selector {
        margin-bottom: 20px;
    }
}
</style>
